(() => {
  if (window.camelbackNavigationReady) return;
  window.camelbackNavigationReady = true;
  function closeMenu(restoreFocus) {
    const menu = document.querySelector('.cb-menu[open]');
    if (!menu) return;
    menu.open = false;
    if (restoreFocus) menu.querySelector('summary').focus();
  }
  document.addEventListener('click', (event) => {
    if (event.target.closest('.cb-menu a')) closeMenu(false);
    else if (!event.target.closest('.cb-menu')) closeMenu(false);
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(true); });
  document.addEventListener('focusin', (event) => { if (!event.target.closest('.cb-menu')) closeMenu(false); });
  window.matchMedia('(min-width: 751px)').addEventListener('change', (event) => { if (event.matches) closeMenu(false); });
})();
